import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { useEffect } from "react";
// import { store } from "../state/store";
import { store } from "../store";
import theme from "../Global/theme";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MainRouter from "../Global/routing/MainRouter";
import "../styles.css"
import { GlobalStyles } from "./GlobalStyles";


function App() {
 
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
        <GlobalStyles />
          <MainRouter />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
